import banner from './banner';
import button from './button';

const alert = {
  banner,
  button,
};

const alertVariants = ['alert', 'notice', 'warning', 'white', 'announcement'];

export type AlertVariantsType = 'alert' | 'notice' | 'warning' | 'white' | 'announcement';
export interface AlertType {
  /** The Alert Banner subcomponent types. */
  Banner: AlertVariantsType;
  /** The Alert Button subcomponent types. */
  Button: AlertVariantsType;
}

export { alertVariants };
export default alert;
